<template>
  <div v-if="user">
    <v-divider class="my-2" />

    <v-menu top offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item class="d-flex justify-center my-2" v-bind="attrs" v-on="on">
          <v-list-item-avatar>
            <v-avatar color="primary">
              <span class="white--text">{{ userInitials }}</span>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-left">{{ user.name }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list>
        <v-list-item link @click.prevent="logout">
          <v-list-item-title>{{ $t('navigation.footer.logoutLink') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { notifyError } from '@/modules/notification-center';
import { authentication, logout as dispatchLogout } from '@/modules/authentication';
import { User } from '@/models/user/user';

export default Vue.extend({
  name: 'TheSidebarFooter',
  computed: {
    user(): User | undefined {
      return authentication.user;
    },
    userInitials(): string {
      if (this.user) {
        const { given_name, family_name } = this.user;
        return given_name.charAt(0) + family_name.charAt(0);
      }

      return '';
    }
  },
  methods: {
    async logout() {
      try {
        await dispatchLogout();
        this.$router.push({ name: 'logout' });
      } catch (error) {
        const errorMessage = this.$t('notification.auth.logoutFailed');
        notifyError(errorMessage);
      }
    }
  }
});
</script>
